<ng-container *ngVar="equipments$ | async as equipments">
  <ng-container *ngIf="equipments?.length">
    <mat-card appearance="outlined">
      <mat-card-title>
        <ui-svg-icon [name]="iconNameList.Box" [width]="32" class="tw-align-middle"></ui-svg-icon>
        <span>{{ 'waybill.transportContent.equipments.title' | translate }}</span>
      </mat-card-title>

      <mat-table [dataSource]="equipments" multiTemplateDataRows noDataTableMessage>
        <ng-container matColumnDef="equipmentCodeQualifier">
          <mat-header-cell *matHeaderCellDef>
            {{ 'waybill.transportContent.equipments.th.equipmentCodeQualifier' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex">
            {{
              'waybill.transportContent.equipments.equipmentCodeQualifiers.' +
                (hasEquipmentCodeQualifier(equipments[i]?.equipmentCodeQualifier)
                  ? equipments[i]?.equipmentCodeQualifier
                  : equipmentCodeQualifierEnum.Unknown) | translate
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>
            {{ 'waybill.transportContent.equipments.th.equipmentId' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex">
            {{ equipments[i]?.id | nullToNotAvailable }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="equipmentType">
          <mat-header-cell *matHeaderCellDef class="tw-basis-1/12">
            {{ 'waybill.transportContent.equipments.th.equipmentType' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex" class="tw-basis-1/12">
            <div
              *ngIf="
                equipments[i]?.equipmentSizeAndTypeDescriptionCode && equipments[i]?.equipmentSizeAndTypeDescription;
                else codeOrDescriptionAvailableTemplate
              "
              cropText
            >
              {{
                equipments[i]?.equipmentSizeAndTypeDescription
                  ?.toLocaleLowerCase()
                  .includes(equipments[i]?.equipmentSizeAndTypeDescriptionCode?.toLocaleLowerCase())
                  ? equipments[i]?.equipmentSizeAndTypeDescription
                  : equipments[i]?.equipmentSizeAndTypeDescription +
                    ':' +
                    equipments[i]?.equipmentSizeAndTypeDescriptionCode
              }}
            </div>

            <ng-template #codeOrDescriptionAvailableTemplate>
              <div
                *ngIf="
                  equipments[i]?.equipmentSizeAndTypeDescriptionCode || equipments[i]?.equipmentSizeAndTypeDescription;
                  else notAvailableTemplate
                "
              >
                {{
                  equipments[i].equipmentSizeAndTypeDescriptionCode
                    ? equipments[i].equipmentSizeAndTypeDescriptionCode
                    : equipments[i].equipmentSizeAndTypeDescription
                }}
              </div>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="full">
          <mat-header-cell *matHeaderCellDef>
            {{ 'waybill.transportContent.equipments.th.full' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex">
            <ng-container [ngSwitch]="equipments[i]?.full">
              <ng-container *ngSwitchCase="true">
                {{ 'waybill.transportContent.equipments.full' | translate }}
              </ng-container>
              <ng-container *ngSwitchCase="false">
                {{ 'waybill.transportContent.equipments.empty' | translate }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ notAvailable }}
              </ng-container>
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="grossWeight">
          <mat-header-cell *matHeaderCellDef>
            {{ 'waybill.transportContent.equipments.th.grossWeight' | translate }}
            <ng-container *ngIf="weightUnitCode">({{ measurementUnitCodes[weightUnitCode] }})</ng-container>
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex">
            {{ equipments[i]?.grossWeight | nullToNotAvailable }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="chargeableWeight">
          <mat-header-cell *matHeaderCellDef>
            <span cropText>
              {{ 'waybill.transportContent.equipments.th.chargeableWeight' | translate }}
              <ng-container *ngIf="weightUnitCode">({{ measurementUnitCodes[weightUnitCode] }})</ng-container>
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex">
            {{ equipments[i]?.chargeableWeight | nullToNotAvailable }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="volume">
          <mat-header-cell *matHeaderCellDef>
            {{ 'waybill.transportContent.equipments.th.volume' | translate }}
            <ng-container *ngIf="volumeUnitCode">({{ measurementUnitCodes[volumeUnitCode] }})</ng-container>
          </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex">
            {{ equipments[i]?.volume | nullToNotAvailable }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sealNumber">
          <mat-header-cell *matHeaderCellDef>
            {{ 'waybill.transportContent.equipments.th.sealNumber' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let i = dataIndex">
            {{ equipments[i]?.sealNumber | nullToNotAvailable }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expand">
          <mat-header-cell *matHeaderCellDef> &nbsp;</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element; let i = dataIndex">
            <ng-container *ngVar="!equipments[i].materials?.length as noMaterialsAvailable">
              <button
                *ngIf="equipments[i].equipmentCodeQualifier === equipmentCodeQualifierEnum.Cn"
                class="tw-flex tw-items-center"
                [class.disabled]="noMaterialsAvailable"
                [matTooltip]="
                  noMaterialsAvailable
                    ? ('waybill.transportContent.equipments.materials.noMaterials' | translate)
                    : null
                "
                (click)="expand(element.id, noMaterialsAvailable)"
              >
                <span cropText> {{ 'waybill.transportContent.equipments.materials.title' | translate }} </span>
                <ui-svg-icon class="tw-ml-1" [name]="iconNames.Down" [width]="16"></ui-svg-icon>
              </button>
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expanded-detail">
          <mat-cell *matCellDef="let element">
            <div
              class="container-materials"
              [@detailExpand]="element.id === (expandedMaterialId$ | async) ? 'expanded' : 'collapsed'"
            >
              <ui-equipment-materials
                [materials]="element.materials"
                [weightUnitCode]="weightUnitCode"
                [volumeUnitCode]="volumeUnitCode"
              ></ui-equipment-materials>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns" class="tw-flex"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: columns"
          class="tw-flex"
          [class.active-row]="row.id === (expandedMaterialId$ | async)"
        ></mat-row>
        <mat-row
          *matRowDef="let row; columns: ['expanded-detail']; when: hasMaterials"
          class="container-materials-row"
          [class.container-materials-row_expanded]="row.id === (expandedMaterialId$ | async)"
        ></mat-row>
      </mat-table>
    </mat-card>
  </ng-container>
</ng-container>

<ng-template #notAvailableTemplate>
  {{ notAvailable }}
</ng-template>
